import React, {useContext, useEffect, useState} from "react";
import {create} from "@bufbuild/protobuf";
import {isFullSwing, PlayerBaySession_Client} from "../constants";
import Button from "../components/Button";
import {colors} from "../assets/styles/colors";
import AddNewPromoCode from "./User/promos/components/AddNewPromoCode";
import {StoreContext} from "../components/StoreContextProvider";
import {JoinSessionRequestSchema} from "../../generated/player_bay_session_pb";
import {WagerMode} from "../../generated/bay_session_shared_pb";
import MainStyle from "../../MainStyle";

const ActiveFRSButton = () => {
  const [openStationIdDialog, setOpenStationIdDialog] = useState(false);
  const Context = useContext(StoreContext);
  const {cancelModalConfig, bayPlayerJwt} = Context;
  const [isDisabled, setIsDisabled] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  const showError = (subtitle: string) => {
    Context.setCancelModalConfig({
      visible: true, title: 'Error', leftBtnText: 'OK', subtitle,
      onExit: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
    });
  };

  const handleStationIdChange = (id: string) => {
    setOpenStationIdDialog(false);
    joinStation(id);
  };

  // Dev affordance that simulates facial-recognition arrival at a bay by
  // joining the logged-in player to that station's session. This replaces
  // the legacy partner-service "simulate user temporary" RPC; bay-session
  // JoinSession is the BSA-native equivalent (the player is derived from
  // the JWT, the station from the request body). The 120s button cooldown
  // is purely a client-side rate-limit on repeat presses — the join itself
  // is not time-boxed server-side.
  const joinStation = (id: string) => {
    const stationIdNum = Number(id);
    if (!Number.isInteger(stationIdNum) || stationIdNum <= 0) {
      showError('Enter a valid numeric station ID.');
      return;
    }

    if (!bayPlayerJwt) {
      showError('Session not ready — please reload the app.');
      return;
    }

    const request = create(JoinSessionRequestSchema, {
      stationId: BigInt(stationIdNum),
      initialWagerMode: WagerMode.NONE, // venue default; player picks currency later
    });

    PlayerBaySession_Client.joinSession(request, {
      headers: {Authorization: `Bearer ${bayPlayerJwt}`},
    }).then(() => {
      setIsDisabled(true);
      setSecondsLeft(120);

      Context.setCancelModalConfig({
        visible: true, title: 'Success', titleColor: MainStyle.c_green, leftBtnText: 'OK',
        subtitle: `You have joined station ${id}`,
        onExit: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
      });

    }).catch(err => {
      console.log('joinSession err', err);

      if (err.message) showError(err.message);
    });
  };

  useEffect(() => {
    if (!isDisabled) return;

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsDisabled(false);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [isDisabled]);

  return (
    <>
      {isFullSwing && (
        <Button
          text={isDisabled ? formatTime(secondsLeft) : 'Active FRS for 2 mins'} borderWidth={1} disabled={isDisabled}
          onPress={() => setOpenStationIdDialog(true)} bg="transparent" fontWeight="600" mb={10} w="100%"
          borderColor={colors.white} color="white" fontSize={20}
        />
      )}

      <AddNewPromoCode
        isOpen={openStationIdDialog} onClose={() => setOpenStationIdDialog(false)} inputType="numeric"
        title="Add Station ID" inputPlaceholder="Station ID" onSubmit={handleStationIdChange}
      />
    </>
  );
};

export default ActiveFRSButton;
